import { colors } from 'fitify-ui'
import { TextStyles } from 'fitify-ui-landing/src/components/Text'
import styled from 'styled-components'

import { NAVIGATION_HEIGHT } from '../../Navigation/Navigation.Styled'

export const StyledMobileAppFeatures = styled.div`
  position: relative;
  flex-direction: column;
`

export const StyledMobileAppFeaturesAnchor = styled.div`
  position: absolute;
  top: -${NAVIGATION_HEIGHT}px;
  width: 1px;
  height: 1px;
`

export const StyledMobileAppFeature = styled.div`
  & + & {
    margin-top: 60px;
  }

  place-items: center center;
  text-align: center;

  ${TextStyles} {
    padding-top: 32px;
    text-align: left;
    b {
      color: ${colors.Black};
    }
  }
`
